import { createClient } from "@sanity/client";
import { createImageUrlBuilder } from "@sanity/image-url";

export const sanityConfig = {
  // Public identifiers (not secrets); env vars override them per environment.
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID || "cqnxj3kw",
  dataset: process.env.REACT_APP_SANITY_DATASET || "production",
  apiVersion: "2025-01-01",
  useCdn: true,
};

export const sanityClient = createClient(sanityConfig);

const builder = createImageUrlBuilder(sanityClient);

export const urlFor = (source) => builder.image(source);
